import { EVENT_PAYLOAD, IMPRESSION_PAYLOAD, } from '#pplx/frontend/framework/instrumentation/types.js';
export const talkToSalesCtaViewedEvent = IMPRESSION_PAYLOAD;
export const talkToSalesCtaSelectedEvent = EVENT_PAYLOAD;
export const talkToSalesPopoverOpenedEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map